@file:OptIn(InternalResourceApi::class)

package ejobin.composeapp.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/ejobin.composeapp.generated.resources/"

internal val Res.drawable.compose_multiplatform: DrawableResource by lazy {
      DrawableResource("drawable:compose_multiplatform", setOf(
        ResourceItem(setOf(), "${MD}drawable/compose-multiplatform.xml", -1, -1),
      ))
    }

internal val Res.drawable.eJobin_logo: DrawableResource by lazy {
      DrawableResource("drawable:eJobin_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/eJobin_logo.png", -1, -1),
      ))
    }

internal val Res.drawable.whatsapp_logo: DrawableResource by lazy {
      DrawableResource("drawable:whatsapp_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/whatsapp_logo.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("compose_multiplatform", Res.drawable.compose_multiplatform)
  map.put("eJobin_logo", Res.drawable.eJobin_logo)
  map.put("whatsapp_logo", Res.drawable.whatsapp_logo)
}
